import { toPrecision } from '@curbnturf/helpers';
import { IAmenity, IListing, IListingPoint } from '../interfaces';
import { Address } from './address';
import { Amenity } from './amenity';
import { Listing } from './listing';
import { MapPoint } from './map-point';

export class ListingPoint extends MapPoint implements IListingPoint {
  syncId?: string;
  amenities?: IAmenity[];
  price?: number;
  lowPrice?: number;
  highPrice?: number;
  availableSiteCount?: number;
  listing?: IListing;

  public static fromListing(listing: IListing | Listing): ListingPoint {
    const mapPoint = new this();

    if (listing.coordinates) {
      mapPoint.coordinates = {
        lat: toPrecision(listing.coordinates.lat, 2),
        lon: toPrecision(listing.coordinates.lon, 2),
      };
    }

    if (listing.id && listing.name) {
      mapPoint.id = listing.id;
      mapPoint.name = listing.name;
    }

    if (listing.description) {
      mapPoint.description = listing.description;
    }

    if (listing.photos) {
      mapPoint.photos = listing.photos;
    } else {
      mapPoint.photos = [];
    }

    if (listing.address && listing.address.city && listing.address.state) {
      mapPoint.location = `${listing.address.city}, ${listing.address.state}`;
    } else if (listing.address && listing.address.city) {
      mapPoint.location = `${listing.address.city}`;
    } else if (listing.address && listing.address.state) {
      mapPoint.location = `${listing.address.state}`;
    } else {
      mapPoint.location = '';
    }

    if (listing instanceof Listing) {
      mapPoint.price = listing.getMinPriceWithTax();
      mapPoint.lowPrice = listing.getMinPriceWithTax();
      mapPoint.highPrice = listing.getMaxPriceWithTax();
      mapPoint.rating = listing.getRating();
      mapPoint.ratingCount = listing.getRatingCount();
      mapPoint.availableSiteCount = listing.sites?.filter((site) => site.available).length || 1;
    }

    mapPoint.listing = listing;

    return mapPoint;
  }

  constructor(data?: IListingPoint) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  setData(data: IListingPoint): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (data.address) {
      this.address = new Address(data.address);
    }

    if (data.amenities) {
      this.amenities = data.amenities.map((amenity) => {
        if (typeof amenity === 'string') {
          return new Amenity({ type: amenity });
        }

        return new Amenity(amenity);
      });
    }

    if (data.listing) {
      this.listing = new Listing(data.listing);
    }
  }

  getName(): string {
    if (this.id === 1) {
      return 'Curb<span class="trinidad">N</span>Turf HQ';
    }

    return this.name || 'Unidentified Property';
  }
}
